<mat-accordion multi class="nav-accordion">
  @for (item of items; track item.name) {
    @if (item.children) {
      <mat-expansion-panel class="nav-group" [expanded]="isExpanded(item)">
        <mat-expansion-panel-header class="nav-group-header" [collapsedHeight]="'36px'" [expandedHeight]="'36px'">
          <span class="nav-group-title">
            <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
            <span class="nav-label">{{ item.name }}</span>
          </span>
        </mat-expansion-panel-header>
        <ul class="nav-group-items">
          @for (child of item.children; track child.name) {
            @if (child.heading) {
              <li class="nav-subheading">{{ child.name }}</li>
            } @else {
              <li>
                <a [routerLink]="child.route" routerLinkActive="nav-link-active" class="nav-link">
                  <mat-icon aria-hidden="true">{{ child.icon }}</mat-icon>
                  <span class="nav-label">{{ child.name }}</span>
                </a>
              </li>
            }
          }
        </ul>
      </mat-expansion-panel>
    } @else {
      <a [routerLink]="item.route" routerLinkActive="nav-link-active" class="nav-top-link">
        <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
        <span class="nav-label">{{ item.name }}</span>
      </a>
    }
  }
</mat-accordion>
